import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableContainerProps,
  TableHead,
  TableRow,
} from '@mui/material'
import { ReactNode } from 'react'

export interface DataTableColumn<Row> {
  headerName: string
  field: keyof Row
  renderCell?: (props: {
    row: Row
    column: DataTableColumn<Row>
    value: unknown
  }) => ReactNode
}

export interface DataTableProps<Row>
  extends TableContainerProps {
  columns: DataTableColumn<Row>[]
  rows: Row[]
}

export function DataTable<Row>({
  columns,
  rows,
  ...props
}: DataTableProps<Row>) {
  return (
    <TableContainer {...props}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map(({ headerName }, i) => (
              <TableCell key={i}>{headerName}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={`row-${i}`}>
              {columns.map((column, i) => (
                <TableCell key={`col-${i}`}>
                  {column.renderCell
                    ? column.renderCell({
                        row,
                        column,
                        value: row[column.field],
                      })
                    : row &&
                      typeof row === 'object' &&
                      column.field in row
                    ? (row[column.field] as ReactNode)
                    : ''}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
